module.exports = __webpack_public_path__ + "static/media/letter--big.93826fd4.png";